import { useUi } from '../ui/ui-store.ts';

export function Toast() {
  const message = useUi((s) => s.toast);

  return (
    <div class={message ? 'toast show' : 'toast'} role="status" aria-live="polite">
      {message ?? ''}
    </div>
  );
}
